/* IssueUserNode.tsx generated by @compiled/babel-plugin v0.38.1 */
import "./IssueUserNode.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
import { useIntl } from 'react-intl-next';
import Avatar, { AvatarItem } from '@atlaskit/avatar';
import { cx } from '@atlaskit/css';
import { Box } from '@atlaskit/primitives/compiled';
import Tooltip from '@atlaskit/tooltip';
import { messages } from '../messages';
var styles = {
  avatar: "_18u0x0bf"
};
export var IssueUserNode = function IssueUserNode(_ref) {
  var user = _ref.user;
  var _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  var User = !Boolean(user) ? /*#__PURE__*/React.createElement(AvatarItem, {
    avatar: /*#__PURE__*/React.createElement(Avatar, {
      appearance: "circle",
      size: "small",
      name: "unassigned"
    }),
    primaryText: formatMessage(messages.unassigned)
  }) : /*#__PURE__*/React.createElement(Tooltip, {
    content: user === null || user === void 0 ? void 0 : user.name
    // don't need a screen reader announcement as the
    // tooltip content is the same as the items content
    ,
    isScreenReaderAnnouncementDisabled: true
  }, /*#__PURE__*/React.createElement(AvatarItem, {
    avatar: /*#__PURE__*/React.createElement(Avatar, {
      appearance: "circle",
      src: user === null || user === void 0 ? void 0 : user.picture,
      size: "small",
      name: user === null || user === void 0 ? void 0 : user.name
    }),
    primaryText: user === null || user === void 0 ? void 0 : user.name
  }));
  return /*#__PURE__*/React.createElement(Box, {
    xcss: cx(styles.avatar)
  }, User);
};